import { getChannelConfigurations } from '@connect-x-app/hybrid-data-access';
import { ApiError, GetChannelConfigurationsResponse, QueryKeys } from '@connect-x-app/shared-domain-models';
import { DEFAULT_PAGE_SIZE } from '@connect-x-app/shared-utils';
import { InfiniteData, QueryKey, useInfiniteQuery } from '@tanstack/react-query';

export const useGetChannelConfigurations = () => {
  return useInfiniteQuery<
    GetChannelConfigurationsResponse,
    ApiError,
    InfiniteData<GetChannelConfigurationsResponse>,
    QueryKey,
    number
  >({
    getNextPageParam: ({ items, limit, offset }) => {
      if (items?.length !== limit) {
        return undefined;
      }
      return offset + limit;
    },
    initialPageParam: 0,
    queryFn: ({ pageParam }) => getChannelConfigurations({ limit: DEFAULT_PAGE_SIZE, offset: pageParam }),
    queryKey: [QueryKeys.CHANNELS],
  });
};
